<template>
  <div v-if="show" class="modal-mask" @click="handleBackdropClick">
    <div class="modal-dialog modal-dialog-centered" @click.stop>
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ trans("admin.cdr.dismissalTitle") }}
          </h5>
          <button type="button" class="close" @click="close">
            <span>&times;</span>
          </button>
        </div>

        <form @submit.prevent="handleSubmit">
          <div class="modal-body">
            <p class="text-muted small">
              {{ trans("admin.cdr.dismissDescription") }}
            </p>

            <div class="form-group mb-3">
              <label for="dismissal-note" class="form-label">
                {{ trans("admin.cdr.dismissalNote") }}
                <span class="text-danger">*</span>
              </label>
              <textarea
                id="dismissal-note"
                v-model="note"
                class="form-control"
                rows="3"
                :placeholder="trans('admin.cdr.dismissalNotePlaceholder')"
              />
            </div>

            <div class="alert alert-warning mb-0">
              <div class="form-check">
                <input
                  id="dismiss-acknowledge"
                  v-model="acknowledged"
                  type="checkbox"
                  class="form-check-input"
                />
                <label class="form-check-label" for="dismiss-acknowledge">
                  {{ trans("admin.cdr.dismissAcknowledge") }}
                </label>
              </div>
            </div>
          </div>

          <div class="modal-footer">
            <button
              type="button"
              class="btn btn-secondary"
              :disabled="submitting"
              @click="close"
            >
              {{ trans("general.modalCancelButton") }}
            </button>
            <button
              type="submit"
              class="btn btn-primary"
              :disabled="!canSubmit"
            >
              {{ trans("admin.cdr.dismissFlag") }}
            </button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import { practitionerHttpService } from "../../app/practitioner-portal/store/practitioner-http-service";

export default {
  props: {
    show: { type: Boolean, required: true },
    flag: { type: Object, required: true },
    apiUrl: { type: String, required: true },
  },
  emits: ["close", "updated"],
  data() {
    return {
      submitting: false,
      acknowledged: false,
      note: "",
    };
  },
  computed: {
    canSubmit() {
      return (
        this.acknowledged && this.note.trim().length > 0 && !this.submitting
      );
    },
  },
  watch: {
    show(visible) {
      if (visible) {
        this.acknowledged = false;
        this.note = "";
      }
    },
  },
  methods: {
    close() {
      if (this.submitting) {
        return;
      }
      this.$emit("close");
    },
    handleBackdropClick() {
      this.close();
    },
    handleSubmit() {
      if (!this.canSubmit) {
        return;
      }

      this.submitting = true;
      practitionerHttpService
        .post(this.apiUrl + this.flag.id + "/dismiss", {
          acknowledge: true,
          dismissal_note: this.note.trim(),
        })
        .then((res) => {
          this.submitting = false;
          this.$emit("updated", res.data);
          this.$emit("close");
        })
        .catch((error) => {
          this.submitting = false;
          this.userErrorMessage(error);
        });
    },
  },
};
</script>
